export const CASE_TYPE = {
  HOSPITAL_DISCHARGE: 'Alta hospitalaria',
  CUT_REVIEW: 'Revision de corte',
};

export const CASE_TYPE_SLA_FLAG = Object.freeze([
    "Alta hospitalaria",
    "Alta hospitalario",
    "Alta express",
    "Reconsideración de Alta",
    "Reconsideración de Alta",
]);

export const REGISTRATION_CASE_TYPE = Object.freeze([
    "Alta hospitalaria",
    "Alta hospitalario",
    "Alta express",
    "Reconsideración de Alta",
    "Reconsideración de Alta",
]);